import React, { Component } from 'react';
import Button from '@material-ui/core/ButtonBase';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import SpotlioIcon from '../Icon';

import './NumericStepper.scss';

class NumericStepper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.default ? this.props.default : 0,
            max: this.props.max ? this.props.max : 50,
            min: this.props.min !== undefined ? this.props.min : 1,
            hasChanged: this.props.make ? true : false,
            open: false
        }
    }

    shouldComponentUpdate(nextProps){
        if (this.props.value === undefined){
            if (!this.state.hasChanged){
                return false
            } else {
                return true;
            }
        } else {
            return true;
        }
        
    }

    componentWillReceiveProps(nextProps){
        if (this.state.value !== nextProps.default){
            this.setState({value: nextProps.default})
        }
    }
    renderDropdownItems = () => {
        return (
            Array.from(new Array(this.state.max + 1 - this.state.min), (val, idx) =>
                <MenuItem key={idx + this.state.min} value={idx+this.state.min}>{(idx+this.state.min).toString()}</MenuItem>
            )
        );
    }

    handleChange = (event) => {
        this.setState({
            value: event.target.value,
            hasChanged: true,
        }, () => this.props.whenChange(this.props.name, this.state.value))
    }

    handleChangeDecrease = () => {
        const val = this.props.value ? this.props.value : this.state.value;
        if (val > 0 && val > this.state.min) {
            this.setState({
                value: val - 1,
                hasChanged: true
            }, () => this.props.whenChange(this.props.name, this.state.value))
        }
    }

    handleChangeIncrease = () => {
        const val = this.props.value ? this.props.value : this.state.value;
        if (val < this.state.max) {
            this.setState({
                value: val + 1,
                hasChanged: true
            }, () => this.props.whenChange(this.props.name, this.state.value))
        }
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.label && 
                    <span onClick={() => this.setState({ open: true })}>
                        {this.props.label}
                    </span>
                }
                <div className="numericStepper">
                    {this.props.onlyDropDown ?
                    <Select
                        variant={'outlined'}
                        name={this.props.name}
                        value={this.props.value !== undefined ? this.props.value : this.state.value}
                        onChange={this.handleChange}
                        className={"bigDropDown " + (!this.props.className ? 'default' : this.props.className)}
                        inputProps={{
                            name: 'ammount'
                        }}
                        renderValue={(value)=>
                            <React.Fragment>
                                {this.props.x !== undefined ? <React.Fragment>x {value}</React.Fragment> : this.props.showName ? !this.state.hasChanged ? <React.Fragment>{this.props.name} <SpotlioIcon size={16} icon={'feather-chevron-down'}/></React.Fragment> : <React.Fragment>{value + " " + this.props.name }<SpotlioIcon size={16} icon={'feather-chevron-down'}/></React.Fragment> : <React.Fragment>{value}</React.Fragment>}
                            </React.Fragment>

                        }
                    >
                        { this.renderDropdownItems() }
                    </Select>
                    :
                    <React.Fragment>
                        <Button variant="contained" className="general cta small first primary" onClick={this.handleChangeDecrease}>
                            -
                        </Button>
                        <Select
                            open={this.state.open} 
                            onClose={() => this.setState({ open: false })}
                            onOpen={() => this.setState({ open: true })}
                            name={this.props.name}
                            value={this.props.value ? this.props.value : this.state.value}
                            onChange={this.handleChange}
                            className={"Dropdown " + (!this.props.className ? ' default' : this.props.className)}
                            inputProps={{
                                name: 'ammount'
                            }}
                        >
                            { this.renderDropdownItems() }
                        </Select>
                        <Button variant="contained" className="general cta small last primary" onClick={this.handleChangeIncrease}>
                            +
                        </Button>
                    </React.Fragment>
                    }
                </div>
            </React.Fragment>
        );
    }
}

export default NumericStepper;
